export default {
  "global_my-profile": "My Profile",
  "global_my-accounts": "My Accounts",
  "global_resources": "Learn",
  "global_notifications": "Notifications",
  "global_id": "SA ID",
  "global_unread-label": "Unread",
  "global_no-messages": "There are no messages.",
  "global_show-more-messages": "Show More Messages",
  "global_my-documents": "My Documents",
  "global_account-plan-settings": "Account & Plan Settings",
  "global_personal-information": "Personal Information",
  "global_contact-information": "Contact Information",
  "global_account-information": "Account Information",
  "global_banking-information": "Banking Information",
  "global_personal-settings": "Personal Settings",
  "global_hsa-settings": "HSA Settings",
  "global_hsa-account": "HSA Account",
  "global_veba-settings": "VEBA Settings",
  "global_fsa-settings": "FSA Settings",
  "global_hra-settings": "HRA Settings",
  "global_payment-banking": "Payment & Banking",
  "global_communications": "Communications",
  "global_see-all-settings": "See All Settings",
  "global_log-out": "Sign Out",
  "global_sign-out-warning": "Are you sure you want to sign out?",
  "global_accounts": "My Accounts",
  "global_account": "Account",
  "global_banking": "Banking",
  "global_contact": "Contact",
  "global_account-balance": "Available Balance",
  "global_inactive-accounts": "Inactive Accounts",
  "global_transaction-alerts": "Transaction Alerts",
  "global_posted": "Posted",
  "global_received": "Received",
  "global_tax-year": "Tax Year",
  "global_note": "Note",
  "global_attachments": "Attachments",
  "global_attachment": "Attachment",
  "global_attach-document": "Attach Document",
  "global_attach-documents": "Attach Documents",
  "global_add-note": "Add Note",
  "global_print": "Print",
  "global_review": "Review",
  "global_terms-and-conditions": "Terms & Conditions",
  "global_terms-and-conditions-action-statement": "Please review and agree to the terms and conditions for opening a Health Savings Account.",
  "global_update-transaction": "Update Transaction",
  "global_cancel-transaction": "Cancel Transaction",
  "global_manage-account": "Manage Account",
  "global_see-all-activity": "See All Activity",
  "global_overview": "Overview",
  "global_activity": "Activity",
  "global_eligibility": "Eligibility",
  "global_statements": "Statements",
  "global_account-statements": "Account Statements",
  "global_tax-forms": "Tax Forms",
  "global_date-range": "Date Range",
  "global_search": "Search",
  "global_summary": "Summary",
  "global_source": "Source",
  "global_claim-number": "Claim Number",
  "global_service-type": "Service Type",
  "global_patient": "Patient",
  "global_provider": "Provider",
  "global_service-from-date": "Service From Date",
  "global_service-to-date": "Service To Date",
  "global_amount-submitted": "Amount Submitted",
  "global_amount-approved": "Amount Approved",
  "global_denial-adjustment-reason": "Denial/Adjustment Reason",
  "global_pending": "Pending",
  "global_available-balance": "Available Balance",
  "global_invested": "Invested",
  "global_total-balance": "Total Balance",
  "global_unprocessed-transactions": "Unprocessed Claims",
  "global_contributions": "Contributions",
  "global_taxes": "Taxes",
  "global_results": "Results",
  "global_individual-max": "Individual Max",
  "global_family-max": "Family Max",
  "global_max-with-rollover": "Max with rollover",
  "global_min-spending-goal": "Min. Spending Goal",
  "global_minimum": "Minimum",
  "global_investments": "Investments",
  "global_edit": "Edit",
  "global_delete": "Delete",
  "global_view-account": "View Account",
  "global_view-info": "View Info",
  "global_get-reimbursed": "Get Reimbursed",
  "global_make-deposit": "Make a Deposit",
  "global_pay-bill": "Pay a Bill",
  "global_match-to-transaction": "Match to Transaction",
  "global_invest": "Invest",
  "global_manage-card": "Manage My Card",
  "global_pagination-page-span": "From %pageStart% to %pageStop%",
  "global_recent-activity": "Recent Activity",
  "global_providers": "Providers",
  "global_add-provider": "Add Provider",
  "global_add-beneficiary": "Add Beneficiary",
  "global_effective-date-label": "Effective Date",
  "global_username": "Username",
  "global_menu": "Menu",
  "global_manage-banking": "Manage Banking",
  "global_update-beneficiary": "Update Beneficiary",
  "global_remove-beneficiary": "Remove Beneficiary",
  "global_primary": "Primary",
  "global_secondary": "Contingent",
  "global_account-number": "Account Number",
  "global_routing-number": "Routing Number",
  "global_bank-name": "Bank Name",
  "global_account-type": "Account Type",
  "global_submit-claim": "Submit a Claim",
  "global_remove": "Remove",
  "global_cancel": "Cancel",
  "global_ok": "OK",
  "global_debit-card": "Debit Card",
  "global_automatic-claim-submission": "Automatic Claim Submission",
  "global_primary-card-holder": "Primary Card Holder",
  "global_spouse": "Spouse",
  "global_child": "Child",
  "global_parent": "Parent",
  "global_sibling": "Sibling",
  "global_other": "Other",
  "global_medical": "Medical",
  "global_pay-the-provider": "Pay the Provider",
  "global_dental": "Dental",
  "global_yes": "Yes",
  "global_no": "No",
  "global_make-changes": "Make Changes",
  "global_primary-account": "Primary Account",
  "global_checking": "Checking",
  "global_savings": "Savings",
  "global_save": "Save",
  "global_save-bank-account": "Save Bank Account",
  "global_add-bank-account": "Add Bank Account",
  "global_im-done": "I’m Done",
  "global_save-changes": "Save Changes",
  "global_title_confirm-close": "Are you sure you want to cancel?",
  "global_text_confirm-close": "No changes will be made.",
  "global_action_confirm-close_cancel": "Cancel",
  "global_action_confirm-close_confirm": "Confirm",
  "global_confirm": "Confirm",
  "global_non-discrimination": "Non-Discrimination",
  "global_legal-terms-of-use": "Legal Terms of Use",
  "global_privacy-policy": "Privacy Policy",
  "global_security-policy": "Security Policy",
  "global_contact-us": "Contact Us",
  "global_home": "Home",
  "global_accessibility-close": "close",
  "global_agree": "Agree",
  "global_disagree": "Disagree",
  "global_continue": "Continue",
  "global_next": "Next",
  "global_log-in": "Sign in",
  "global_submit": "Submit",
  "global_register": "New User? Register",
  "global_payment-method": "Payment Method",
  "global_bank-accounts": "Bank Accounts",
  "global_bank-account": "Bank Account",
  "global_related": "Related",
  "global_questions": "Questions?",
  "global_health-savings-account": "Health Savings Account",
  "global_hsa": "HSA",
  "global_flexible-spending-account": "Flexible Spending Account",
  "global_fsa": "FSA",
  "global_loading": "Loading…",
  "global_unprocessed": "Unprocessed",
  "global_required-indicator": "*indicates required field",
  "global_date-picker_action_cancel": "Cancel",
  "global_date-picker_action_confirm": "OK",
  "global_manage-preferences": "Manage Preferences",
  "global_your-contact-info": "Your Contact Info",
  "global_unsubmitted": "Unsubmitted",
  "global_submitted": "Submitted",
  "global_communication-preferences": "Communication Preferences",
  "global_release-authorization": "Release Authorization (ARI)",
  "global_ari-designees": "ARI Designees",
  "global_ari-designee": "ARI Designee",
  "global_account-status": "Account Status",
  "global_hsa-plan": "HSA Plan",
  "global_health-plan-coverage": "Health Plan Coverage",
  "global_beneficiaries": "Beneficiaries",
  "global_beneficiary": "Beneficiary",
  "global_view": "View",
  "global_updated": "Updated %date%",
  "global_learn-more": "Learn More",
  "global_manage": "Manage",
  "global_action": "Action",
  "global_name": "Name",
  "global_or": "or",
  "global_i-want-to": "I Want To",
  "global_i-want-to-ellipsis": "I Want To…",
  "global_no-transactions": "No recent transactions found.",
  "global_success": "Success",
  "global_hsa-withdrawal-request": "HSA Withdrawal Request",
  "global_medical-expense": "Medical Expense",
  "global_dependent-care-expense": "Dependent Care Expense",
  "global_premium-reimbursement": "Premium Reimbursement",
  "global_current-year": "Current Year",
  "global_release-hold": "Release Hold",
  "global_set-hold": "Set Hold",
  "global_on-hold": "On Hold",
  "global_active": "Active",
  "global_download": "Download",
  "global_not-applicable": "N/A",
  "global_skip": "Skip",
  "global_initial-loading-text": "Member Portal Loading…",
  "global_select-one": "Select One",
  "global_requested": "Requested",

  // FORM LABELS
  "___global_form-label_account-number": "",
  "global_form-label_confirm-account-number": "Confirm Account Number",
  "___global_form-label_routing-number": "",
  "___global_form-label_account-type": "",
  "___global_form-label_bank-name": "",
  "global_form-label_first-name": "First Name",
  "global_form-label_last-name": "Last Name",
  "global_form-label_dob": "Date of Birth",
  "global_form-label_addr-1": "Address Line 1",
  "global_form-label_addr-2": "Address Line 2",
  "global_form-label_non-us-addr-1": "Non US Address Line 1",
  "global_form-label_non-us-addr-2": "Non US Address Line 2",
  "global_form-label_non-us-addr-3": "Non US Address Line 3",
  "global_form-label_city": "City",
  "global_form-label_state": "State",
  "global_form-label_zip": "Zip Code",
  "global_form-label_phone": "Phone Number",
  "global_form-label_secondary-phone": "Secondary Number",
  "global_form-label_email": "Email",
  "global_form-label_edit-info": "Edit Info",
  "global_form-label_SMS": "SMS",
  "global_form-label_confirm-email": "Confirm Email",
  "global_form-label_selectaccount-id": "SA ID",
  "global_form-label_ssn": "Social Security Number",
  "global_form-label_ssn-last-4": "Last 4 digits of SSN",
  "global_form-label_username": "Username",
  "global_form-label_password": "Password",
  "global_form-label_confirm-password": "Confirm Password",
  "global_form-label_question": "Question",
  "global_form-label_custom-question": "Custom Question",
  "global_form-label_answer": "Answer",
  "global_form-label_service-from-date": "Service From Date",
  "global_form-label_service-to-date": "Service To Date",
  "global_form-label_provider-name": "Provider Name",
  "global_powered-by": "Powered By",

  // FORM ERRORS
  "global_form-error_token_required": "A pin is required.",
  "global_form-label_token": "Temporary Pin",
  "global_form-error_default_required": "This field is required",
  "global_form-error_default_invalid-format": "Invalid format",
  "global_form-error_date_invalid-format": "Invalid date",
  "global_form-error_dob_invalid": "The Date of Birth cannot be a future date.",
  "global_form-error_start-date_invalid": "Start date must be prior to end date",
  "global_form-error_end-date_invalid": "End date must be prior to start date",
  "global_form-error_account-number_required": "Account number is required",
  "global_form-error_confirm-account-number_required": "Confirm account number is required",
  "global_form-error_routing-number_required": "Routing number is required",
  "global_form-error_account-type_required": "Account type is required",
  "global_form-error_bank-name_required": "Bank name is required",
  "global_form-error_first-name_required": "First name is required",
  "global_form-error_last-name_required": "Last name is required",
  "global_form-error_dob_required": "Date of birth is required",
  "global_form-error_select-account-id_required": "SelectAccount ID is required",
  "global_form-error_address-required": "Address is required",
  "global_form-error_city-required": "City is required",
  "global_form-error_state-required": "State is required",
  "global_form-error_zip-required": "Zip code is required",
  "global_form-error_phone-required": "Phone number is required",
  "global_form-error_phone-invalid-format": "Invalid phone number format",
  "global_form-error_email_required": "Email is required",
  "global_form-error_confirm-email_required": "Confirm email is required",
  "global_form-error_selectaccount-id_required": "SelectAccount ID is required",
  "global_form-error_ssn_required": "Social security number is required",
  "global_form-error_ssn-last-4_required": "Last 4 digits of SSN is required",
  "global_form-error_username_required": "Username is required",
  "global_form-error_password_required": "Password is required",
  "global_form-error_confirm-password_required": "Confirm password is required",
  "global_form-error_question_required": "Question is required",
  "global_form-error_custom-question_required": "Custom question is required",
  "global_form-error_answer_required": "Answer is required",
  "global_form-error_terms-and-conditions_required": "The Terms & Conditions field is required",
  "global_logged-out_session-expired": "Your session has timed out, please log in again.",
  "global_logged-out_successful": "You have successfully logged out.",
  "global_make-elections": "Make Elections",
  "global_single": "Single",
  "global_family": "Family",

  // FORM HINTS
  "global_form-hint_date": "MM/DD/YYYY",
  "global_form-hint_phone": "(XXX) XXX-XXXX",
  "global_form-hint_zip": "XXXXX or XXXXX-XXXX",

  // LOADING/SUCCESS/ERROR MESSAGING
  "global_text_error-title": "An Error Occurred",
  "global_text_error-message_default": "Unable to process information at this time. Please try again.",
  "global_text_success-message_default": "Success!",
  "global_try-again": "Try Again",
  "global_dismiss": "Dismiss",
  "global_validating-token": "Validating Token...",
  "global_forgot-password": "Forgot Password?",
  "global_forgot-username": "Forgot Username?",
  "global_forgot-username-statement": "Forgot Username?",
  "global_finding-data": "Finding your information…",
  "global_connection-error": "Information unavailable. Please try again.",
  "global_refresh": "Refresh",
  "global_preferences-updates": "Success! Your updates have been saved.",
  "global_csr-error": "You are unable to perform the requested transaction due to your CSR role.",
  "global_leaving-site": "Are you sure you want to leave?",
  "global_leaving-site_content": "By accessing this link, you will be leaving the Further website and entering a site hosted by another party. By accessing this link, you will no longer be subject to, or under the protection of, the privacy and security policies of the Further website.",
  "global_migrated-member-error": "You have been transferred to Health Equity and must make updates to your account at my.healthequity.com",
  "global_blackout-member-error": "You are currently in a blackout period as we are preparing to transfer your account. As a result, all online functionality has been suspended. We apologize for any inconvenience."
};
